<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="container">
    <HeaderLayout :title="`${this.$store.getters.userInfo.tenant.shortName}管网GIS全览图`" workTitle="工作台"
      workUrl="/pipe-network/workbench" />
    <div class="main">
      <big-map ref="bigmap" code="new_pipe_network_legend" />
    </div>
  </div>
</template>
<script>

import HeaderLayout from '@/layouts/HeaderLayout.vue'
import BigMap from './components/NewBigMap.vue'

export default {
  components: {
    [BigMap.name]: BigMap,
    HeaderLayout
  },
  data () {
    return {
      map: null,
      openyxcxTable: false,
      openQueryTable: false,
      opensscxTable: false,
      opendlcsTable: false,
      diameter: '',
      material: '',
      sscxInputData: null,
      radioGroupValue: 1,
      cqlString: ''
    }
  },
  mounted () {
    // 检查是否从列表页跳转过来，需要定位到指定坐标
    this.$nextTick(() => {
      this.checkAndLocateFromQuery()
    })
  },
  methods: {
    // 检查路由参数并定位到指定坐标
    checkAndLocateFromQuery () {
      const { type, geoJson, classNo, startClassNo, endClassNo, name } = this.$route.query
      
      console.log('NewOneMap 接收到的路由参数:', { type, geoJson, classNo, name });
      
      // 统一处理：管点和管线都使用完整 GeoJSON 数据
      if (geoJson) {
        try {
          const geoData = JSON.parse(geoJson)
          console.log(`定位到${type === 'line' ? '管线' : '管点'}（完整数据）:`, { geoData, name })
          
          // 延迟执行，确保地图已完全初始化
          setTimeout(() => {
            console.log('延迟1秒后执行，检查地图引用:', {
              bigmap: !!this.$refs.bigmap,
              gisMap: !!(this.$refs.bigmap && this.$refs.bigmap.$refs.gisMap)
            });
            
            if (this.$refs.bigmap && this.$refs.bigmap.$refs.gisMap) {
              if (type === 'line' && geoData.type === 'LineString') {
                // 管线类型
                console.log('调用 locateToLineString');
                this.$refs.bigmap.$refs.gisMap.locateToLineString(geoData, {
                  startClassNo,
                  endClassNo,
                  name
                })
              } else if (type === 'point' && geoData.type === 'Point') {
                // 管点类型
                console.log('调用 locateToPoint');
                this.$refs.bigmap.$refs.gisMap.locateToPoint(geoData, {
                  classNo,
                  name
                })
              } else {
                console.error('GeoJSON 类型不匹配:', geoData.type, type)
                this.$message.error('数据类型不匹配')
              }
            } else {
              console.error('地图组件引用未找到');
              this.$message.error('地图加载失败');
            }
          }, 1000)
          
          // 清除URL参数
          this.$router.replace({ 
            path: this.$route.path,
            query: {} 
          }).catch(() => {})
        } catch (error) {
          console.error('解析 GeoJSON 失败:', error, geoJson)
          this.$message.error('数据格式错误')
        }
      } else {
        console.warn('缺少 GeoJSON 数据，路由参数:', this.$route.query)
       // this.$message.warning('缺少坐标数据')
      }
    }
  }

}
</script>
<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;

  .main {
    flex: 1;
    overflow: hidden;
    min-height: 0; // 重要：确保flex子元素可以收缩
  }
}
</style>
